import { call, put, takeEvery } from "redux-saga/effects"

import {
  GET_ADMIN_SCHEDULED_REPORTS,
  CREATE_ADMIN_SCHEDULED_REPORTS,
  UPDATE_ADMIN_SCHEDULED_REPORTS,
  DELETE_ADMIN_SCHEDULED_REPORTS,
  GET_ADMIN_SCHEDULED_REPORT_LOGS_BY_ID,
  REDIRECT_TO_ADMIN_DOWNLOAD_URL
} from "./actionTypes"

import {
  getAdminScheduledReportsSuccess,
  getAdminScheduledReportsError,
  createAdminScheduledReportsSuccess,
  createAdminScheduledReportsError,
  updateAdminScheduledReportsSuccess,
  updateAdminScheduledReportsError,
  deleteAdminScheduledReportsSuccess,
  deleteAdminScheduledReportsError,
  getAdminScheduledReportLogsByIdSuccess,
  getAdminScheduledReportLogsByIdError,
  redirectToAdminDownloadUrlSuccess,
  redirectToAdminDownloadUrlError
} from "./actions"

import { genericDeleteRequest, genericGetRequest, genericGetRequest_2, genericPostRequest, genericPutRequest } from "helpers/sf_backend_helper.js"
import { bsh_getAdminUserDetails } from "helpers/sf_browser_storage_helper"

import { AppConfiguration } from "config"

// Admin scheduled reports are accountless — admin auth only, NO `account-id` header.
function* onGetAdminScheduledReports() {
  try {
    let user = bsh_getAdminUserDetails()
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_scheduled_reports`,
      {},
      {
        Authorization: user.token,
        'Content-Type': 'application/json',
      }
    )
    yield put(getAdminScheduledReportsSuccess(response))
  } catch (error) {
    yield put(getAdminScheduledReportsError(error))
  }
}

function* onCreateAdminScheduledReports(action) {
  try {
    let user = bsh_getAdminUserDetails()
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_scheduled_reports`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json',
        }
      }
    )
    yield put(createAdminScheduledReportsSuccess(response))
  } catch (error) {
    yield put(createAdminScheduledReportsError(error))
  }
}

function* onUpdateAdminScheduledReports(action) {
  try {
    let user = bsh_getAdminUserDetails()
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_scheduled_reports/${action.payload.ids.join(',')}`,
      {
        body: JSON.stringify({
          ...action.payload.body
        }),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(updateAdminScheduledReportsSuccess(response))
  } catch (error) {
    yield put(updateAdminScheduledReportsError(error))
  }
}

function* onDeleteAdminScheduledReports(action) {
  try {
    let user = bsh_getAdminUserDetails()
    const response = yield call(
      genericDeleteRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_scheduled_reports/${action.payload.id}`,
      {
        headers: {
          Authorization: user.token,
        }
      }
    )
    yield put(deleteAdminScheduledReportsSuccess(response))
  } catch (error) {
    yield put(deleteAdminScheduledReportsError(error))
  }
}

function* onGetAdminScheduledReportLogsById(action) {
  try {
    let user = bsh_getAdminUserDetails()
    const response = yield call(
      genericGetRequest_2,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_scheduled_report_logs`,
      action.payload.queryParams,
      {
        Authorization: user.token,
        'Content-Type': 'application/json',
      }
    )
    yield put(getAdminScheduledReportLogsByIdSuccess(response, action.admin_scheduled_report_id))
  } catch (error) {
    yield put(getAdminScheduledReportLogsByIdError(error))
  }
}

function* onGetAdminScheduledReportDownloadUrl(action) {
  try {
    let user = bsh_getAdminUserDetails()
    const response = yield call(
      genericGetRequest_2,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_scheduled_report_uploads/presigned_url`,
      { id: action.payload },
      {
        Authorization: user.token,
        'Content-Type': 'application/json',
      }
    )
    yield put(redirectToAdminDownloadUrlSuccess(response?.data))
  } catch (error) {
    yield put(redirectToAdminDownloadUrlError(error))
  }
}

function* AdminScheduledReports() {
  yield takeEvery(GET_ADMIN_SCHEDULED_REPORTS, onGetAdminScheduledReports)
  yield takeEvery(CREATE_ADMIN_SCHEDULED_REPORTS, onCreateAdminScheduledReports)
  yield takeEvery(UPDATE_ADMIN_SCHEDULED_REPORTS, onUpdateAdminScheduledReports)
  yield takeEvery(DELETE_ADMIN_SCHEDULED_REPORTS, onDeleteAdminScheduledReports)
  yield takeEvery(GET_ADMIN_SCHEDULED_REPORT_LOGS_BY_ID, onGetAdminScheduledReportLogsById)
  yield takeEvery(REDIRECT_TO_ADMIN_DOWNLOAD_URL, onGetAdminScheduledReportDownloadUrl)
}

export default AdminScheduledReports;
